import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '../../../../common/components/button'
import { useStyles } from './toggle.style'

export const Toggle = ({
  className,
  isOn,
  iconOn,
  iconOff,
  tooltipOn,
  tooltipOff,
  onChange,
  ...props
}) => {
  const classes = useStyles()

  return <Button
    variant="icon-link"
    tooltipLabel={isOn ? tooltipOn : tooltipOff}
    className={`${className ? className + ' ' : ''}${classes.toggle}${isOn ? ' active' : ''}`}
    {...props}
    onClick={(event) => {
      onChange(event)
      event.currentTarget.blur() // If we do not blur, the button will look like it is toggled when it is not.
    }}
  >
    <FontAwesomeIcon icon={isOn ? iconOn : iconOff} size='xl'/>
  </Button>
}
